var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCertifiedBadgeEn = function SvgCertifiedBadgeEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 20,
    x: 1,
    y: 1,
    fill: "#fff",
    rx: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 20,
    x: 1,
    y: 1,
    stroke: "#fff",
    strokeWidth: 2,
    rx: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 20,
    x: 1,
    y: 1,
    stroke: "url(#certified-badge-en_svg__a)",
    strokeOpacity: 0.34,
    strokeWidth: 2,
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.539 5a.2.2 0 0 1 .197.167l.064.378c.458 1.715 1.589 2.182 2.2 2.182V11c0 2.743-3.667 5.143-5.5 6-1.833-.857-5.5-3.257-5.5-6V7.727c.611 0 1.742-.467 2.2-2.182l.064-.378A.2.2 0 0 1 12.46 5h6.078Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "m15.115 12.5 3.3-3.5m-3.378 3.5-1.79-1.937"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.116 7.223V15H25.72V7.223zM31.11 15h-2.643V7.223h2.686c2.32 0 3.727 1.46 3.727 3.878 0 2.427-1.407 3.899-3.77 3.899m-1.246-1.214h1.17c1.623 0 2.45-.891 2.45-2.685 0-1.784-.827-2.664-2.406-2.664h-1.214zm9.693-6.563 2.02 6.133h.086l2.03-6.133h1.536L42.478 15H40.76l-2.74-7.777h1.536Zm8.398 7.895c-1.762 0-2.836-1.17-2.836-2.997 0-1.805 1.095-3.03 2.76-3.03 1.429 0 2.664.892 2.664 2.944v.43h-4.07c.015.994.6 1.579 1.492 1.579.602 0 1.01-.258 1.182-.602h1.343c-.247 1.01-1.182 1.676-2.535 1.676m-1.472-3.588h2.75c-.01-.795-.537-1.375-1.332-1.375-.827 0-1.375.629-1.418 1.375M51.506 15V9.167h1.332v.967h.064c.204-.666.774-1.053 1.44-1.053.15 0 .365.01.494.032v1.268a2.4 2.4 0 0 0-.634-.086c-.762 0-1.321.526-1.321 1.268V15zm4.046 0V9.167h1.375V15zm.699-6.66c-.43 0-.795-.333-.795-.752 0-.408.365-.741.795-.741.44 0 .794.333.794.74 0 .42-.354.753-.794.753m4.841.827v1.053h-1.203V15h-1.375v-4.78h-.87V9.167h.87v-.559c0-1.138.709-1.75 1.826-1.75.322 0 .612.032.87.085v1.085a4 4 0 0 0-.494-.043c-.559 0-.827.226-.827.752v.43zM61.969 15V9.167h1.375V15zm.699-6.66c-.43 0-.795-.333-.795-.752 0-.408.365-.741.795-.741.44 0 .795.333.795.74 0 .42-.355.753-.795.753m4.476 6.778c-1.762 0-2.836-1.17-2.836-2.997 0-1.805 1.096-3.03 2.76-3.03 1.43 0 2.665.892 2.665 2.944v.43H65.66c.017.994.602 1.579 1.494 1.579.601 0 1.01-.258 1.181-.602h1.343c-.247 1.01-1.181 1.676-2.535 1.676Zm-1.472-3.588h2.75c-.01-.795-.537-1.375-1.332-1.375-.827 0-1.375.629-1.418 1.375m7.194 3.577c-1.375 0-2.406-1.095-2.406-3.018 0-1.944 1.063-2.997 2.417-2.997 1.031 0 1.46.612 1.665 1.031h.054v-2.9h1.364V15h-1.343v-.924h-.075c-.215.43-.666 1.031-1.676 1.031m.376-1.127c.881 0 1.386-.763 1.386-1.902 0-1.128-.494-1.869-1.386-1.869-.913 0-1.386.784-1.386 1.87 0 1.106.484 1.9 1.386 1.9Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "certified-badge-en_svg__a",
    x1: 0,
    x2: 87,
    y1: 11,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopColor: "#ECCA20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#195EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3E9F01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF13C4"
  })))));
};
export default SvgCertifiedBadgeEn;